import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';


@Injectable({
  providedIn: 'root'
})
export class ConsoleRightsService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService) { }
  get(): Observable<any> {
    const headers=this.httpHeaderService.bearerHttpAuthorizationHeader();
       return this.httpclient.get(environment.servicePath + '/console_rights',{headers});
  }
}
